"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slideAsset = _interopRequireDefault(require("./slideAsset"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable implicit-arrow-linebreak */

/**
 * Schema for a Resource
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var Resource = function Resource(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['Resource', {
    name: {
      type: String,
      required: true,
      minlength: 1,
      trim: true
    },
    type: {
      type: String,
      required: true
    },
    subType: {
      type: String
    },
    createdAt: {
      type: Date,
      required: true
    },
    updatedAt: {
      type: Date
    },
    createdBy: {
      type: String
    },
    disabledAt: {
      type: Date
    },
    active: {
      type: Boolean,
      "default": true
    },
    courses: [{
      type: objectIdType,
      ref: 'Course'
    }],
    version: {
      type: Number
    },
    /** For most Resources (Image, Audio) */
    filename: {
      type: String
    },
    thumbnail: {
      type: String
    },
    url: {
      type: String
    },
    /** For Stateful Resource */
    files: [{
      filename: {
        type: String,
        required: true
      },
      state: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      url: {
        type: String
      }
    }],
    /** For Document Resource */
    content: {
      type: String,
      "default": null
    },
    indexedContent: {
      type: String,
      "default": null
    },
    /** For Document v2 Resource */
    styleId: {
      type: objectIdType
    },
    /** Outline Styling overrides for articles/sections */
    outlineTemplate: {
      type: Object
    },
    /** Annotations on Document Resources */
    annotations: [(0, _slideAsset["default"])(objectIdType)],
    /** Orientation for Document Resource */
    isLandscape: {
      type: Boolean
    },
    /** For Audio Resource */
    captions: {
      type: String
    },
    captionsQueued: {
      type: Boolean
    },
    duration: {
      type: Number
    },
    transcriptionResults: {
      type: Object
    }
  }];
};
var _default = Resource;
exports["default"] = _default;